import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { ArrowRight } from '../../ui/icons/classic/regular';

export default function Loading({ results }: componentTypes.LoadingProps) {
  return (
    <div className="flex flex-wrap gap-y-4.5 md:gap-y-6 lg:gap-y-8 md:-mx-2 lg:-mx-4">
      {Array.from({ length: results.hitsPerPage }, (_, index) => (
        <div key={index} className={`w-full md:px-2 lg:px-4${index > 0 ? ' md:w-1/2' : ''}`}>
          <div className="group/card block relative z-10 no-underline overflow-hidden rounded-lg animate-pulse">
            <div className="bg-grey-100" />
            <div
              className={`w-full flex flex-col justify-between gap-y-6 aspect-[5/4]${index === 0 ? ' md:aspect-[16/9]' : ''} after:absolute after:inset-0 after:-z-10 after:bg-linear-(--card-case) p-6 md:p-8 lg:p-10 text-white`}
            >
              <span className="w-14 h-4 md:h-4.5 lg:h-5 bg-white" />
              <div className="flex justify-between items-end gap-x-3 lg:gap-x-24 xl:gap-x-32">
                <div className="bg-white h-4.5 md:h-6 lg:h-7.5 w-85" />
                <ArrowRight
                  iconClass="w-4 md:w-5 lg:w-5.5 mr-4 mb-2 md:mb-1 transition-all duration-500 group-hover/card:translate-x-4 group-focus/card:translate-x-4"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
